import React, { useState } from "react";
import { Modal, Form, Input, Button, Typography } from "antd";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { ShowToast, Severty } from "../../helper/toast";
import { MailOutlined } from "@ant-design/icons";
const { Text, Paragraph } = Typography;

const ForgotPassword = ({ visible, setVisible, openOTP, setEmail }) => {

  const { request } = useRequest();
  const [form]      = Form.useForm();
  const [resetLoading, setResetLoading] = useState(false);
  
  const handleResetPassword = async (values) => {
    setResetLoading(true);
    try {
      const payload = { email: values.email };
      await request({
        url: apiPath.forgotPassword,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setResetLoading(false);
          ShowToast(data.message, Severty.SUCCESS);
          form.resetFields();
          setVisible(false);
          setEmail(values.email);
          openOTP(true);
        },
        onError: (error) => {
          setResetLoading(false);
          ShowToast(error?.response?.data?.message || "Something went wrong", Severty.ERROR);
        },
      });
    } catch (err) {
      setResetLoading(false);
      ShowToast(err.message, Severty.ERROR);
    }
  };

  return (
    <Modal
      open={visible}
      title={null}
      onCancel={() => setVisible(false)}
      footer={null}
      destroyOnClose
      centered
      className="p-0"
    >
      <div className="p-4 sm:p-4 w-full max-w-md mx-auto">

        <div className="flex flex-col items-center mb-4">
          <div className="bg-[#94C13E] text-white rounded-full p-4 mb-2">
            <MailOutlined className="text-2xl" />
          </div>

          <h2 className="text-xl font-semibold text-gray-800">Forgot Password</h2>
          <Paragraph className="text-center text-gray-600 mt-2 text-sm">
            Enter your registered email address. We will send a <strong>4-digit OTP</strong> to your email to verify your account.
          </Paragraph>
        </div>

        <Form form={form} layout="vertical" onFinish={handleResetPassword}>
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              { type: "email", message: "Enter a valid email!" },
              { max: 255, message: "Max 255 characters!" },
              { required: true, message: "Email is required!" },
            ]}
          >
            <Input
              autoComplete="off"
              placeholder="Enter Email Address"
              className="rounded-md border-gray-300 focus:border-[#94C13E] focus:ring focus:ring-[#94C13E]/50"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={resetLoading}
            className="w-full bg-[#94C13E] hover:bg-[#82b32e] text-white font-medium py-2 rounded-md transition duration-200"
          >
            Send OTP
          </Button>
        </Form>
      </div>
    </Modal>
  );
};

export default ForgotPassword;

